import Swal from "sweetalert2";
export const imageAlert = (title,text) => {
    Swal.fire({ text: text});
}